// extracted by mini-css-extract-plugin
export default {"container":"UlrOZd","block":"ahc81F"};